import { render, staticRenderFns } from "./VehiclesList.vue?vue&type=template&id=3972d509&scoped=true"
import script from "./VehiclesList.vue?vue&type=script&lang=js"
export * from "./VehiclesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3972d509",
  null
  
)

export default component.exports